<template>
  <status-string
    :class="
      ediType === EdiType.Extranet
        ? status === ESignatureStatus.Signed1C
          ? 'text-yellow'
          : 'text-green'
        : 'text-inactive'
    "
    :text="
      ediType === EdiType.Extranet
        ? status === ESignatureStatus.Signed1C
          ? 'Ожидает подписания'
          : 'Подписан'
        : 'Стороннее ЭДО'
    "
  />
</template>

<script setup lang="ts">
import StatusString from '@/core/components/common/StatusString.vue';
import { EdiType, ESignatureStatus } from '@/graphql/generated';

defineProps<{
  ediType: EdiType;
  status: ESignatureStatus | undefined | null;
}>();
</script>
